import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./auth.service";

export const adminAuthGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toLogin = () =>
    router.createUrlTree(["/login"], {
      queryParams: { redirect: router.url },
    });

  const restored = await auth.restoreSession();
  if (!restored) return toLogin();
  if (auth.idleExceeded()) {
    await auth.logout();
    return toLogin();
  }
  auth.touch();
  return true;
};
